import { HttpService } from './http-service';
import { Settings } from '@/models/settings/settings';

export class SettingsService extends HttpService {
    protected getResourceUrl() { return 'api/settings' };
    protected getResponseMapper() { return Settings.parseJson }
}

export const settingsService = new SettingsService();
